import React from 'react';
import '../../../apps/metlas-landing/src/LandingPageV2.css';
import { SubpageHeader, SubpageFooter } from '../../../apps/metlas-landing/src/SubpageChrome';
import './PrivacyPolicyTerms.css';

const PrivacyPolicyTerms: React.FC = () => {
  return (
    <div className="mlp-page">
      <SubpageHeader />
      <main>
        <header className="legal-hero">
          <div className="mlp-wrap">
            <p className="mlp-kicker mlp-kicker--kb">Legal</p>
            <h1 className="legal-hero-title">
              Privacy <em>&amp; terms.</em>
            </h1>
          </div>
        </header>

        <div className="mlp-wrap legal-layout">
          <nav className="legal-toc" aria-label="On this page">
            <a href="#privacy">Privacy Policy</a>
            <a href="#terms">Terms of Service</a>
          </nav>

          <div className="legal-content">
            <section id="privacy" className="legal-section">
              <h2 className="legal-title">Privacy Policy</h2>
              <p className="legal-date">Last Updated: March 20, 2026</p>

              <h3>1. Information We Collect</h3>
              <p>We collect information to provide better services to our users. This includes:</p>
              <ul>
                <li>
                  <strong>Information you provide:</strong> Such as your name and email address when
                  you create an account.
                </li>
                <li>
                  <strong>Google User Data:</strong> If you choose to connect your Google Account,
                  we access specific data authorized by you (e.g., your email address or profile
                  information).
                </li>
              </ul>

              <h3>2. How We Use Google User Data</h3>
              <p>
                Our use of information received from Google APIs will adhere to the Google API
                Service User Data Policy, including the Limited Use requirements. Specifically, we
                use this data to:
              </p>
              <ul>
                <li>Authenticate your identity and secure your account.</li>
                <li>Personalize your user experience.</li>
              </ul>
              <p>We do not sell your Google user data to third parties.</p>

              <h3>3. With Whom We Share, Transfer, or Disclose Google User Data</h3>
              <p>
                We may share, transfer, or disclose Google User Data only as described below and
                only to the extent necessary to provide the service and comply with applicable law:
              </p>
              <ul>
                <li>
                  <strong>Google:</strong> We share Google User Data with Google as required to
                  provide authentication and access to data through Google APIs.
                </li>
                <li>
                  <strong>Service providers:</strong> We may disclose Google User Data to vendors
                  who help us operate and secure the service (for example, cloud hosting and
                  infrastructure providers) only to perform services on our behalf and under
                  appropriate confidentiality obligations.
                </li>
                <li>
                  <strong>Legal and regulatory authorities:</strong> We may disclose Google User
                  Data if we believe disclosure is required by law, regulation, legal process, or to
                  protect our rights and safety, or those of others.
                </li>
                <li>
                  <strong>Business transfers:</strong> If we are involved in a merger, acquisition,
                  or sale of assets, Google User Data may be transferred as part of that
                  transaction, subject to applicable laws and safeguards.
                </li>
              </ul>

              <h3>4. Data Retention and Deletion</h3>
              <p>
                We retain your data only as long as necessary to provide our services. You may
                revoke access to your Google data at any time via your Google Security Settings or
                by contacting us to delete your account.
              </p>
            </section>

            <section id="terms" className="legal-section">
              <h2 className="legal-title">Terms of Service</h2>
              <p className="legal-date">Last Updated: March 20, 2026</p>

              <h3>1. Acceptance of Terms</h3>
              <p>
                By accessing our services, you agree to be bound by these terms. If you do not
                agree, please do not use the service.
              </p>

              <h3>2. User Accounts</h3>
              <p>
                When you create an account (including via Google Sign-In), you are responsible for
                maintaining the security of your credentials. You agree to provide accurate and
                complete information.
              </p>

              <h3>3. Prohibited Conduct</h3>
              <p>You agree not to:</p>
              <ul>
                <li>Use the service for any illegal purpose.</li>
                <li>Attempt to gain unauthorized access to our systems or other users' data.</li>
                <li>Interfere with the proper working of the service.</li>
              </ul>

              <h3>4. Limitation of Liability</h3>
              <p>
                The service is provided &quot;as is.&quot; To the maximum extent permitted by law,
                Metlas shall not be liable for any indirect, incidental, or consequential damages
                arising from your use of the service.
              </p>

              <h3>5. Changes to Terms</h3>
              <p>
                We reserve the right to modify these terms at any time. We will notify users of
                significant changes by posting the new terms on this page.
              </p>
            </section>
          </div>
        </div>
        <SubpageFooter />
      </main>
    </div>
  );
};

export default PrivacyPolicyTerms;
